module.exports = __webpack_public_path__ + "img/About_ys_big_1.62beb37e.jpg";